<template>
  <q-btn
    :dense="!isRoundButton"
    :round="isRoundButton"
    :ripple="false"
    :loading="loading"
    :disable="disable"
    :color="selectedNonDefaultLanguage ? 'amber-2' : undefined"
    data-test-id="translate-language-select"
  >
    <q-avatar size="30px">
      <country-flag
        class="language-select-flag"
        rounded
        :country="getCountryFlagKeyForLanguage(modelValue)"
      />
    </q-avatar>
    <span
      v-if="!isRoundButton"
      class="q-ml-sm"
    >{{ currentLanguageLabel }}</span>
    <q-tooltip
      v-if="isRoundButton"
      anchor="center right"
      self="center left"
      :offset="[10, 0]"
    >
      {{ currentLanguageName }}
    </q-tooltip>
    <q-menu>
      <q-list>
        <q-item-label
          class="q-pb-xs"
          header
        >
          {{ menuHeaderText }}
        </q-item-label>
        <q-item
          v-for="option in currentCircuit.availableLanguagesOptions"
          :key="option.value"
          v-close-popup
          :class="{ 'cursor-not-allowed': modelValue === option.value }"
          :clickable="modelValue !== option.value"
          :active="modelValue === option.value"
          @click="$emit('update:model-value', option.value)"
        >
          <q-item-section
            class="flag-section"
            avatar
          >
            <country-flag
              class="language-select-flag"
              :country="getCountryFlagKeyForLanguage(option.value)"
            />
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ option.label }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>

<script>
import { EN, getCountryFlagKeyForLanguage } from 'src/i18n'

const LABEL_STYLES = {
  LONG: 'long',
  SHORT: 'short',
  ICON: 'icon'
}

export default {
  name: 'TranslateLanguageSelect',
  configuration: ['currentCircuit'],
  props: {
    labelStyle: {
      type: String,
      default: LABEL_STYLES.ICON
    },
    disable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    menuHeaderText: {
      type: String,
      required: false,
      default: 'View Translations'
    }
  },
  emits: ['update:model-value'],
  computed: {
    isRoundButton () {
      return this.labelStyle === LABEL_STYLES.ICON
    },
    currentLanguageName () {
      return this.$i18n.t(`languages.${this.modelValue}`)
    },
    currentLanguageLabel () {
      if (this.labelStyle === LABEL_STYLES.ICON) {
        return ''
      } else if (this.labelStyle === LABEL_STYLES.LONG) {
        return this.currentLanguageName
      } else {
        return this.currentLanguageName.substring(0, 3)
      }
    },
    selectedNonDefaultLanguage () {
      return this.modelValue !== EN
    }
  },
  created () {
    _.extend(this, { getCountryFlagKeyForLanguage })
  }
}
</script>

<style scoped>
.flag-section {
  min-width: 30px;
}
/* Using two classes for greater precedence */
.language-select-flag.normal-flag {
  margin-top: -10px;
  margin-left: -13px;
}
</style>
